import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import './FollowersModal.css';
import profileIcon from '../Icons/profile-menu.png';
import {useAuth} from '../Auth/AuthContext';
import {useFollowing} from '../context/FollowingContext';

const FollowersModal = ({followers, following, userNames, userProfiles = {}, onClose}) => {
  const [tab, setTab] = useState('followers');
  const {userId: currentUserId} = useAuth();
  const { following: myFollowing, followUser, unfollowUser } = useFollowing();

  const handleFollowUser   = (uid) => followUser(uid);
  const handleUnfollowUser = (uid) => unfollowUser(uid);

  const userList = tab === 'followers' ? followers : following;

  return (
    <div className="followers-modal-overlay" onClick={onClose}>
      <div className="followers-modal-content" onClick={e => e.stopPropagation()}>
        <div className="followers-modal-tabs">
          <button className={tab === 'followers' ? 'active' : ''} onClick={() => setTab('followers')}>Seguidores</button>
          <button className={tab === 'following' ? 'active' : ''} onClick={() => setTab('following')}>Seguidos</button>
        </div>
        <div className="followers-modal-list">
          {userList.length > 0 ? (
            <ul>
              {userList.map(uid => (
                <li key={uid} className="followers-modal-user">
                  <Link to={`/profile/${uid}`} className="followers-modal-user-link">
                    <img
                      src={userProfiles[uid]?.profileImage || profileIcon}
                      alt="Perfil"
                      className="followers-modal-profile-img"
                    />
                    <span>{userNames[uid] || uid}</span>
                  </Link>
                  {uid !== currentUserId && (
                    myFollowing.includes(uid) ? (
                      <button
                        className="unfollow-button"
                        onClick={() => handleUnfollowUser(uid)}
                      >
                        Dejar de Seguir
                      </button>
                    ) : (
                      <button
                        className="follow-button"
                        onClick={() => handleFollowUser(uid)}
                      >
                        Seguir
                      </button>
                    )
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p>{tab === 'followers' ? 'No tiene seguidores.' : 'No sigue a nadie.'}</p>
          )}
        </div>
        <button className="followers-modal-close" onClick={onClose}>Cerrar</button>
      </div>
    </div>
  );
};

export default FollowersModal;